import { Component, OnInit, Input } from '@angular/core';
import { Product } from '../../interfaces/product.interface';
import { PlanAttributes, SummaryView } from '../../interfaces/plan-attributes.interface';
import { environment } from 'src/environments/environment';
import { BrandingConfigurationService } from '@ptl/brand';
import { ContentStorageService } from '@ptl/global-components';

@Component({
    selector: 'app-indicator-icons',
    templateUrl: './indicator-icons.component.html',
    styleUrls: ['./indicator-icons.component.scss'],
    standalone: false
})
export class IndicatorIconsComponent implements OnInit {

  @Input() plan: Product<PlanAttributes, SummaryView>;
  
  /*
  tooltipsND = {
    DENTAL: `Pediatric coverage includes routine dental exams every 6 months.`,
    VISION: `Pediatric coverage includes new standard eyeglasses and frames or contact lenses annually.`,
    HEARING: `Coverage includes new hearing aids annually.`,
    RX: `Coverage includes prescription drugs on our formulary.`,
    MEDICAL: `See this plan's details for complete details.`
  }
  */
  
  config = {
    DENTAL: { imgFile:'shopcard_dental.svg', imgAlt:'Dental Coverage', tooltip: 'Coverage includes routine dental exams every 6 months.' },
    VISION: { imgFile:'shopcard_vision.svg', imgAlt:'Vision Coverage', tooltip: 'Coverage includes new standard eyeglasses and frames or contact lenses annually.' },
    HEARING: { imgFile:'shopcard_hearing.svg', imgAlt:'Hearing Coverage', tooltip: 'Coverage includes new hearing aids annually.' },
    RX: { imgFile:'shopcard_prescription.svg', imgAlt:'Prescription Coverage', tooltip: 'Coverage includes prescription drugs on our formulary.' },
    MEDICAL: { imgFile:'shopcard_medical.svg', imgAlt:'Medical Coverage', tooltip: `Coverage for health care providers, outpatient services, labs and screening are included. See this plan's benefits document for complete details.` }
  }

  angularHostUrl: string;

  constructor(
    private contentStorageService: ContentStorageService,
    private brandService: BrandingConfigurationService
  ) { }

  ngOnInit(){
    this.angularHostUrl = `${environment.infrastructure.googleCloud.angularHostUrl}assets/images/indicator-icons/`;
    
    this.contentStorageService.contentChanged$.subscribe(response => {
      const overrideConfig: Map<string, string> = response?.get("iconTooltipContent");
      if (overrideConfig) {
        overrideConfig.forEach((value, key) => this.config[key].tooltip = value);
      }
    });
  }

}
